import { useState } from "react";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import styles from "../styles/FactoryBuilding.module.css";
import { ArrowRight, ArrowUpRight, Plus, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import container1 from '../assets/Pre-Build/Factory/container.png'
import container2 from '../assets/Pre-Build/Factory/container2.png'
import container3 from '../assets/Pre-Build/Factory/container3.png'
import card1 from '../assets/Pre-Build/Factory/card1.png';
import card2 from '../assets/Pre-Build/Factory/card2.png';
import card3 from '../assets/Pre-Build/Factory/card5.png';
import card4 from '../assets/Pre-Build/Factory/card4.png';
import design from '../assets/Pre-Build/Factory/design.png'
import design1 from '../assets/Pre-Build/Factory/design1.png'
import user1 from '../assets/Pre-Build/Factory/user1.jpg'
import user2 from '../assets/Pre-Build/Factory/user2.jpg'
import user3 from '../assets/Pre-Build/Factory/user3.jpg'
import user4 from '../assets/Pre-Build/Factory/user4.jpg'



const FactoryBuilding = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const [active, setActive] = useState(0);
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const navigate = useNavigate();


  const faqs = [
    {
      q: "What are prefabricated factory buildings?",
      a: "Prefabricated factory buildings are pre-engineered steel structures manufactured off-site and assembled on location, offering faster construction timelines and cost efficiency.",
    },
    {
      q: "Can factory buildings be customized?",
      a: "Yes, our factory buildings can be fully customized with flexible layouts, dimensions, insulation, crane systems, and utilities to meet your specific operational requirements.",
    },
    {
      q: "Are prefab factory buildings durable?",
      a: "Yes, they are built with high-quality steel and engineered for long-lasting strength, stability, and reliable industrial performance.",
    },
    {
      q: "How long does it take to construct a factory building?",
      a: "Most factory buildings are completed within a few weeks, depending on the project size, design, and site requirements.",
    },
    {
      q: "Can the building be expanded in the future?",
      a: "Yes, our modular factory buildings can be easily expanded or modified as your business and production requirements grow.",
    },
  ];


  const industryProjects = [
    {
      title: "Manufacturing Plant Buildings",
      desc: "Modern steel buildings designed for efficient manufacturing operations. Built for durability, large workspaces, and long-term performance.",
      img: card1,
    },
    {
      title: "Heavy Engineering Factory Units",
      desc: "Robust factory buildings engineered for heavy industrial machinery and equipment. Designed to handle demanding operations with maximum strength.",
      img: card2,
    },
    {
      title: "Assembly Line Factory Buildings",
      desc: "Efficient factory structures optimized for streamlined assembly line production. Spacious layouts ensure smooth workflow and higher productivity.",
      img: card3,
    },
    {
      title: "Processing & Production Units",
      desc: "Industrial buildings designed for processing and large-scale production activities. Built for safety, efficiency, and reliable operational performance.",
      img: card4,
    },
  ];


  const processData = [
    {
      title: "Design & Planning",
      description:
        "Detailed factory layout planning based on production workflow, machinery requirements, and load calculations.",
      image: user1,
    },
    {
      title: "Manufacturing",
      description:
        "Fabrication of steel structures and building components using high-quality materials and advanced technology.",
      image: user2,
    },
    {
      title: "Quality & Integration",
      description:
        "Comprehensive quality checks, structural validation, and integration of roofing, insulation, and utility systems.",
      image: user3,
    },
    {
      title: "Installation & Commissioning",
      description:
        "On-site erection, structural alignment, and final commissioning for ready-to-use factory buildings.",
      image: user4,
    },
  ];
  return (
    <>
      <Header />

      {/* HERO */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <span className={styles.topLabel}>L&R PREFAB SOLAR INDIA PVT LDT</span>
          <h1 className={styles.mainTitle}>
            Advanced Factory  <br />
            <span>Building Solutions</span>
          </h1>
          <p className={styles.heroDesc}>Engineered for efficiency, strength, and scalability — L&R Prefab Solar
            delivers high-performance factory buildings for modern manufacturing and industrial operations.</p>
          <button onClick={() => navigate('/contact')} className={styles.btnWhite}>
            <span>Contact Us</span>
            <ArrowRight className={styles.arrow} size={18} />
          </button>
        </div>
      </section>

      {/* INTRO SPLIT */}
      <section className={styles.intro}>
        <span className={styles.introSpan}>• About L&amp;R</span>
        <div className={styles.introText}>
          <h2>L&amp;R Factory<br /><span>Building Solutions</span></h2>
          <div className={styles.introLine}></div>
        </div>
        <div className={styles.introGrid}>
          <div className={styles.introContent}>
            <p>
              L&R Prefab Solar India Pvt Ltd specializes in designing and manufacturing prefabricated
              factory buildings that support efficient production, streamlined operations, and
              long-term industrial performance. Our factory structures are built using high-grade steel
              frameworks and precision engineering to ensure durability, safety, and adaptability across various manufacturing sectors.
            </p>
            <p>
              With a focus on customized solutions, we deliver factory buildings tailored to specific production requirements,
              workflow layouts, and equipment integration. From small-scale units to large manufacturing
              plants, L&R ensures faster construction, optimized space utilization, and reliable structural performance.
            </p>
            <button className={styles.btnOutline} onClick={() => {
              navigate("/contact");
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}>
              <span>Get Contact</span>

              <span className={styles.iconWrap}>
                <ArrowUpRight className={styles.icon1} size={18} />
                <ArrowUpRight className={styles.icon2} size={18} />
              </span>
            </button>
          </div>

          <div className={styles.introImgs}>
            <img src={container2} alt="container" />
          </div>
        </div>
      </section>



      {/* PROJECTS */}
      <section className={styles.productsSec}>
        <div className={styles.productsInner}>
          <div className={styles.productsHeader}>
            <div className={styles.productText}>
              <h2>
                Our Modular Home MS  <br />
                <span>Container Solutions</span>
              </h2>
              <div className={styles.productsDivider}></div>
            </div>
            <p className={styles.productsSubtext}>
              High-quality modular container solutions designed for residential, commercial,
              industrial, and site-based applications with durable mild steel construction.
            </p>
          </div>
          <div className={styles.expertiseGrid}>
            {industryProjects.map((item, index) => (
              <div className={styles.expCard} key={index}>
                <img src={item.img} alt={item.title} className={styles.expImg} />
                <div className={styles.expLabel}>
                  <h4>{item.title}</h4>
                  <div className={styles.desc}>
                    <p>{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className={styles.benefits}>
        <div className={styles.benefitsFlex}>
          <div className={styles.benefitsImg}>
            <img src={container3} alt="container" />
          </div>
          <div className={styles.benefitsText}>
            <div className={styles.benefitsTitle}>
              <h2>L&amp;R Factory<br /><span>Building Benefits</span></h2>
              <div className={styles.introLine}></div>
            </div>
            <p>
              L&R Prefab Solar Inida Factory Buildings Are Engineered To Deliver Superior Structural
              Strength, Large Clear Spans, And Flexibility To Accommodate Modern
              Manufacturing Processes. Our Prefab Solutions Significantly Reduce
              Construction Time While Maintaining High Standards Of Quality And Safety.
            </p>
            <p>
              We Provide Fully Customizable Factory Designs With Options For Crane
              Integration, Mezzanine Floors, Ventilation Systems, And Insulation. Our
              Modular Approach Allows Industries Of All Sizes And Interests To Expand
              Operations Efficiently As Production Demands Grow.
            </p>
          </div>
        </div>
      </section>

      {/* ── Manufacturing Strength ── */}
      <section className={styles.mfgBand}>
        <div className={styles.scrollWrap}>

        </div>

        <div className={styles.mfgContainer}>
          <div className={styles.mfgText}>
            <h2>
              Factory Building  <br />
              Strength & Excellence
            </h2>

            <p>
              L&R Prefab Solar India utilizes advanced fabrication facilities
              equipped with CNC machinery, automated welding systems,
              and precision engineering processes to manufacture industrial
              sheds that meet high standards of strength, accuracy, and performance.
            </p>

            <div className={styles.LastImage}>
              <img src={design1} alt="png" />
            </div>
          </div>

          <div className={styles.mfgImgWrapper}>
            <img
              src={design}
              alt="Manufacturing"
            />
          </div>
        </div>

      </section>


      {/* PROCESS */}
      <section className={styles.processSec}>
        <div className={styles.processHeader}>
          <div className={styles.processtext}>
            <h2>Factory Construction<br /><span>Process by L&amp;R</span></h2>
            <div className={styles.introLine}></div>
          </div>
          <p>
            The Warehouse Process ensures efficient execution from design and fabrication
            to quality assurance and final project handover.
          </p>
        </div>
        <div className={styles.processBody}>
          <div className={styles.processImg}>
            <img
              src={processData[active].image}
              alt={processData[active].title}
              className={styles.processImage}
            />
          </div>
          {/* process */}

          <div className={styles.contentWrapper}>
            {processData.map((item, index) => (
              <div
                key={index}
                className={`${styles.processItem} ${active === index ? styles.active : ""
                  }`}
                onMouseEnter={() => setActive(index)}
              >
                <div className={styles.line}></div>

                <div className={styles.textContent}>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className={styles.faqSec}>
        <span className={styles.introLabel}>• FAQS</span>
        <div className={styles.faqHeader}>
          <div className={styles.faqText}>
            <h2>
              Frequently Asked
              <br />
              <span>Questions</span>
            </h2>
            <div className={styles.FaqsLine}></div>
          </div>
          <p>
            A complete end-to-end factory building solution, from design and
            manufacturing to quality integration and final installation.
          </p>
        </div>

        <div className={styles.faqBody}>
          <div className={styles.faqImg}>
            <img src={container1} alt="container" />
          </div>
          {/*  */}
          <div className={styles.container}>
            {faqs.map((item, index) => (
              <div
                key={index}
                className={`${styles.faqItem} ${activeIndex === index ? styles.active : ""
                  }`}
              >
                <div
                  className={styles.question}
                  onClick={() => toggleFAQ(index)}
                >
                  <h3>{item.q}</h3>

                  <span className={styles.icon}>
                    {activeIndex === index ? (
                      <X size={28} strokeWidth={2} />
                    ) : (
                      <Plus size={28} strokeWidth={2} />
                    )}
                  </span>
                </div>

                <div
                  className={`${styles.answerWrapper} ${activeIndex === index ? styles.open : ""
                    }`}
                >
                  <div className={styles.answer}>
                    <p>{item.a}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* CTA */}
      <section className={styles.cta}>
        <h2>Ready for Your Pre-Engineered Factory Building?</h2>
        <p>
          Connect with our team to design and deliver durable, efficient, and fully
          customized prefabricated building solutions tailored to your site needs.
        </p>


        <button className={styles.contactBtn} onClick={() => {
          navigate("/contact");
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}>
          <span className={styles.contactText}>Contact Us</span>

          <span className={styles.iconBox}>
            <ArrowRight className={styles.iconOne} size={18} />
            <ArrowRight className={styles.iconTwo} size={18} />
          </span>
        </button>
      </section>

      <Footer />
    </>
  );
};

export default FactoryBuilding;